<script>
import { mapStores } from "pinia";

import {
  buildCountTypeHeader,
  buildGenderHeader,
  casusLabels
} from "@/components/article/dictsys/inflectionSchemes/german/labels";
import { mergeInflections } from "@/components/article/dictsys/inflectionSchemes/german/merge-inflections";
import { useSettingsStore } from "@/stores";

import { filterGenders } from "./filter-genders";

export default {
  name: "DesktopInflectionScheme",
  props: {
    scheme: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      casusLabels
    };
  },
  computed: {
    ...mapStores(useSettingsStore),

    wordclassLevel() {
      return this.settingsStore.activeWordClassLevel;
    },
    genders() {
      return filterGenders(this.scheme);
    }
  },
  methods: {
    buildCountTypeHeader,
    buildGenderHeader,
    mergeInflections
  }
};
</script>

<template>
  <table class="table inflection-scheme-modal__table">
    <thead>
      <tr>
        <th scope="col" class="inflection-scheme-modal__th">Kasus</th>
        <th v-for="gender in genders" :key="gender" scope="col" class="inflection-scheme-modal__th">
          {{ buildGenderHeader(wordclassLevel, gender) }}
        </th>
        <th scope="col" class="inflection-scheme-modal__th">
          {{ buildCountTypeHeader(wordclassLevel, "plural") }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(casus, key) in scheme" :key="key" class="inflection-scheme-modal__tr">
        <td class="inflection-scheme-modal__td">
          {{ casusLabels[key] }}
        </td>
        <td v-for="gender in genders" :key="gender" class="inflection-scheme-modal__td" lang="de">
          {{ mergeInflections(casus[gender].singular) }}
        </td>
        <td class="inflection-scheme-modal__td" lang="de">
          {{ mergeInflections(casus.plural) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
